// extracted by mini-css-extract-plugin
export default {"titleDec":"titleDec-zkcJ1u","content":"content-aQmVWr"};